<template>
    <v-card>
        <v-card-title>
            Управление пользователи
        </v-card-title>
        <v-card-text>
            <template>
                <v-data-table
                  :headers="headers"
                  :items="users"
                  :items-per-page="7"
                  class="elevation-1"
                  :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
                >

                <template v-slot:item.actions="{ item }">
                    <v-icon small  class="mr-2"  @click="edit_user(item)">mdi-pencil</v-icon>
                </template>


            </v-data-table>
              </template>

        </v-card-text>

        <v-dialog
          v-model="edit_user_dialog"
          max-width="500"
          @click:outside="close"
        >
          <v-card>
            <v-card-title class="text-h5">
                Редактирование пользователя
            </v-card-title>

        <v-card-text>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                    v-model="user.fio"
                    label="Имя"
                    required
                    :rules="nomRules"
                    hide-details="auto"
                ></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                    v-model="user.tel"
                    label="Телефон"
                    required
                    :rules="phoneRules"
                    hide-details="auto"
                ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="6">
                    <v-text-field
                    v-model="user.password"
                    label="Новый пароль"
                    hide-details="auto"
                    ></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field  v-if="user.dostup==1"
                    v-model="user.shifr"
                    label="Шифр доступа"
                    hide-details="auto"
                    ></v-text-field>

                    <v-select v-if="user.dostup >1"
                        v-model="user.dostup"
                        :items="dostups"
                        label="Доступ"
                        item-text="text"
                        item-value="value"
                        hide-details="auto"
                        ></v-select>
                </v-col>
            </v-row>


          <v-row>
            <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="user.rasm"
                label="Картинки"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="user.izm_narkh"
                label="Изменение цены"
                hide-details
              ></v-checkbox>

              <v-checkbox
                v-model="user.skidka"
                label="Скидка"
                hide-details
              ></v-checkbox>

              <v-text-field v-if="user.skidka>0"
                v-model="user.skidka"
                label="Маржа скидки %"
                hide-details="auto"
                required
                :rules="summaRules"
                ></v-text-field>

            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="user.opt"
                label="Оптовая продажа"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="user.clear"
                label="Очистка список товаров"
                hide-details
              ></v-checkbox>

              <v-checkbox
                v-model="user.oplata_dolg"
                label="Оплата долгов"
                hide-details
              ></v-checkbox>

            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
            >
              <v-checkbox
                v-model="user.add_klent"
                label="Добавление клиентов"
                hide-details
              ></v-checkbox>
              <v-checkbox
                v-model="user.add_raskhod"
                label="Добавление расходов"
                hide-details
              ></v-checkbox>

              <v-checkbox
              v-model="user.add_dokhod"
              label="Добавление доходов"
              hide-details
            ></v-checkbox>
            </v-col>
          </v-row>
          <v-divider></v-divider>

            <v-checkbox
            v-model="user.holat"
            label="Активный пользователь"
            ></v-checkbox>

        </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="error"
                text
                @click="close"
              >
                Отмена
              </v-btn>

              <v-btn
                color="green darken-1"
                text
                @click="change_user"
                :loading="loading"
              >
                Сохранить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
      >
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>

     </v-card>
</template>

<script>
export default {
    data () {
      return {

            snack: false,
            snackColor: '',
            snackText: '',
            loading: false,

        headers: [
          {
            text: '№',
            align: 'start',
            sortable: false,
            value: 'id_user',
          },
          { text: 'ФИО', value: 'fio' },
          { text: 'Тип', value: 'dostup_nom' },
          { text: 'Телефон', value: 'tel' },
          { text: 'Действия', value: 'actions', sortable: false },
        ],

        phoneRules: [
                v => !!v || 'Введите номер телефона',
                v => (v && /^\d+$/.test(v)) || 'Неверный формат номера телефона',
                v => (v && v.length == 9) || 'Неверный формат номера телефона',
            ],

            nomRules: [
            v => !!v || 'Имя обязательно',
            v => (v && v.length <= 100) || 'Название должно быть меньше 100 символов',
            v => (v && v.length >= 3) || 'Название должно быть больше 3 символов',
        ],

        summaRules: [
                v => !!v || 'Введите скидку',
                v => (v && /^\d*(\.\d{1,2})?$/.test(v)) || 'Неверный формат скидка',
            ],



        users: [],
        user:{},
        edit_user_dialog: false,
        settings:[],

        dostups: [
            {text: 'Администратор', value: 2},
            {text: 'Кассир', value: 3},
        ],


      }
    },
    mounted(){
        this.get_users();
    },
    methods:{

        get_users(){
            this.loading = true;
            axios.get('/api/get_users',
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.users = response.data.users;
                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения меню"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });

        },

        edit_user(item){
            this.user = item;
            this.user.password = '';
            this.user.shifr = '';
            this.edit_user_dialog = true;
        },

        change_user(){
            this.loading= true;
            var form = {
                user: this.user,
            }

            axios.post('/api/change_user', form,
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.edit_user_dialog = false;
                                this.snack = true
                                this.snackColor = 'success'
                                this.snackText = "Пользователь изменен"
                                console.log(response.data.message)
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                                this.get_users();
                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка изменения пользователя"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                             console.log(error.response.data.message)
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });
        },

        close(){
            this.user = {};
            this.user.password = '';
            this.user.shifr = '';
            this.edit_user_dialog = false;

        }




    }

}
</script>

<style>

</style>







